/* GoldenLove — Belly Rub cards.

   The flip and the wiggle are CSS, driven by an `is-rubbed` class. This file
   owns two things CSS cannot do: deciding when the pose is on, and emitting
   hearts while it is.

   Interaction model:
     - Fine pointer (mouse): hover holds the pose.
     - Coarse pointer (touch): tap toggles it, and tapping another card closes
       the first, so only one is ever open on a small screen.
     - Keyboard: the toggle is a real <button> with aria-pressed, so focus and
       Enter/Space work with no extra handling.

   Hearts are emitted on an interval only while a card is active, capped, and
   removed on animationend. Nothing is left running when the pose ends.
*/

(function () {
  'use strict';

  var HEART_EVERY = 420;   // ms between hearts
  var MAX_HEARTS = 6;      // concurrent, per card
  var HEART =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M12 21s-8.5-5.6-8.5-11.2A5 5 0 0 1 12 6.6a5 5 0 0 1 8.5 3.2C20.5 15.4 12 21 12 21z"/>' +
    '</svg>';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = window.matchMedia('(pointer: coarse)');

  function emit(card) {
    var layer = card.querySelector('[data-hearts]');
    if (!layer) return;
    if (layer.childElementCount >= MAX_HEARTS) return;

    var heart = document.createElement('span');
    heart.className = 'voffen-belly__heart';
    heart.innerHTML = HEART;

    // Rise from around the belly, with enough variation that no two runs look
    // identical.
    var dur = 1300 + Math.random() * 500;

    heart.style.left = 34 + Math.random() * 32 + '%';
    heart.style.top = 52 + Math.random() * 14 + '%';
    heart.style.setProperty('--drift', (Math.random() * 34 - 17).toFixed(1) + 'px');
    heart.style.setProperty('--tilt', (Math.random() * 40 - 20).toFixed(1) + 'deg');
    heart.style.setProperty('--dur', dur.toFixed(0) + 'ms');

    layer.appendChild(heart);
    // Next frame, so the starting keyframe is painted before the run begins.
    requestAnimationFrame(function () {
      heart.classList.add('is-floating');
    });

    function drop() {
      if (heart.parentNode) heart.parentNode.removeChild(heart);
    }

    // A timer, not animationend alone. animationend proved unreliable here —
    // hearts were observed finished but still in the DOM, which filled the cap
    // and stopped the effect permanently after the first few. The timer is
    // authoritative; the event is just a faster path when it does fire.
    heart.addEventListener('animationend', drop);
    window.setTimeout(drop, dur + 150);
  }

  function activate(card, on) {
    if (card.__rubbed === on) return;
    card.__rubbed = on;

    card.classList.toggle('is-rubbed', on);

    var toggle = card.querySelector('.voffen-belly__toggle');
    if (toggle) toggle.setAttribute('aria-pressed', String(on));

    if (card.__timer) {
      clearInterval(card.__timer);
      card.__timer = null;
    }

    if (!on) {
      // Clear any hearts still in flight, so a card that is re-entered starts
      // from empty rather than from a part-full cap.
      var layer = card.querySelector('[data-hearts]');
      if (layer) layer.textContent = '';
      return;
    }

    if (reduced.matches) return;

    emit(card);
    card.__timer = setInterval(function () {
      emit(card);
    }, HEART_EVERY);
  }

  function init() {
    var cards = document.querySelectorAll('[data-belly]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      if (card.__wired) return;
      card.__wired = true;

      var toggle = card.querySelector('.voffen-belly__toggle');

      // Pointer-type is read per event rather than once at load, so a hybrid
      // laptop behaves correctly whichever input is actually used.
      card.addEventListener('mouseenter', function () {
        if (coarse.matches) return;
        activate(card, true);
      });

      card.addEventListener('mouseleave', function () {
        if (coarse.matches) return;
        activate(card, false);
      });

      if (toggle) {
        toggle.addEventListener('click', function () {
          var next = !card.__rubbed;

          // One at a time on touch, where cards fill the screen.
          if (next && coarse.matches) {
            Array.prototype.forEach.call(cards, function (other) {
              if (other !== card) activate(other, false);
            });
          }

          activate(card, next);
        });

        toggle.addEventListener('focus', function () {
          activate(card, true);
        });

        toggle.addEventListener('blur', function () {
          if (!coarse.matches) activate(card, false);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections are re-rendered as they are edited in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
